import type {Section as MenuSection} from 'common/components/items-menu/types';
import {ExtraResizablePanelAction} from 'common/components/resizable-panel/types';

import {ScrollPosition} from './constants';

export interface SidenavAttrs {
  selected?: string;
  loading?: boolean;
  'min-adjacent-width'?: number;
  header?: SidenavHeader;
  footer?: SidenavFooter;
  'user-id'?: number;
  'storage-key'?: string;
  'fixed-size'?: boolean;
  'is-nested-dashboards-enabled'?: boolean;
}

export interface SidenavState {
  activeDragSectionIdx: number | null;
  collapsedSectionSet: Set<string>;
  expandedItemSet: Set<string>;
  hoveredItemValues: Set<string>;
  isCollapsed: boolean;
  isOverflowMenuOpen: boolean;
  scrollPosition: ScrollPosition;
  selectedItem: SidenavSectionItem | null;
  selectedSectionIndex: number | null;
  scrolledIntoItem: string;
  sections: SidenavSection[];
}

type SidenavCtaHeader = {title?: string; actions: SidenavCta[]};

type SidenavSlotHeader = {title?: string; slot: string; collapsedSlot?: string};

export type SidenavHeader = SidenavCtaHeader | SidenavSlotHeader;
export type SidenavFooter = {
  actions: ExtraResizablePanelAction[];
};

export type SidenavSection = {
  label?: string;
  items: SidenavSectionItem[];
  emptyNotice?: string;
  dragDropEnabled?: boolean;
  isCollapsible: boolean;
};

export type SidenavSectionItem = {
  label: string;
  value: string;
  itemId?: string;
  tooltip?: string;
  userName?: string;
  userId?: number;
  userEmail?: string;

  href?: string;
  target?: string;

  overflowMenuSections?: MenuSection[];
  nestedItems?: SidenavSectionItem[];

  isNew?: boolean;

  [key: string]: any;
};

export enum NestingOrder {
  First = `first`,
  Middle = `middle`,
  Last = `last`,
}

export type SidenavCta = SidenavSectionItem & {
  icon: string;
};

export type PersistedSidenavState = {collapsedSectionSet: string[]; expandedItemSet: string[]};
export type ParsedPersistedSidenavState = Pick<SidenavState, 'collapsedSectionSet' | 'expandedItemSet'>;

export type SidenavItemPosition = {
  parentItem?: SidenavSectionItem;
  sectionIndex?: number;
  itemIndex?: number;
};

export type DragDropEventDetail = {
  item: SidenavSectionItem;
  sectionIndex: number;
  itemIndex: number;

  destinationPosition: SidenavItemPosition;
};
